import React from "react";
import { Alert, AlertTitle, Button } from "@mui/material";

import { Progress } from "ui";

import { useCustomWorkflow } from "fond/hooks/useCustomWorkflow";
import { useAppSelector } from "fond/utils/hooks";

interface GeneratePanelProps {
  // Flag indicating if the editing is read only
  isReadOnly?: boolean;
}

const stageConfig: Record<string, { label: string }> = {
  prepare: { label: "Preparing inputs" },
  bom: { label: "Counting materials and costs" },
  c2s: { label: "Calculating cost to serve" },
};

const GeneratePanel: React.FC<GeneratePanelProps> = ({ isReadOnly }) => {
  const versionId = useAppSelector((state) => state.project.versionId);
  const { workflowState, stages, runWorkflow } = useCustomWorkflow({ versionId, key: "nbn_cost_to_serve" });
  const isGeneratingCTS = workflowState === "STARTING" || workflowState === "IN_PROGRESS";

  const handleGenerateCTS = async () => {
    runWorkflow?.();
  };

  return (
    <>
      {workflowState === undefined && (
        <Alert severity="info" variant="compact" sx={{ mb: 1 }}>
          Cost to serve is ready to generate.
        </Alert>
      )}

      {workflowState === "COMPLETE" && (
        <Alert severity="success" variant="compact" sx={{ mb: 1 }}>
          Cost to serve generated.
        </Alert>
      )}

      {workflowState === "ERROR" && (
        <Alert severity="error" variant="compact" sx={{ mb: 1 }}>
          <AlertTitle>Cost to serve generation failed</AlertTitle>
          Cost to serve could not be generated.
        </Alert>
      )}

      {stages && (isGeneratingCTS || workflowState === "ERROR") && (
        <Progress steps={stages.map(({ key, status }) => ({ ID: key, Label: stageConfig[key].label, Status: status }))} />
      )}

      {workflowState !== "COMPLETE" && (
        <Button
          fullWidth
          variant="contained"
          size="small"
          sx={{ mt: 2 }}
          disabled={!runWorkflow || isGeneratingCTS || isReadOnly}
          onClick={handleGenerateCTS}
        >
          Generate
        </Button>
      )}
    </>
  );
};

export default GeneratePanel;
